import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';

import RoundRadioButton from '../../GeneralComponents/RoundRadioButton';
import MobilePresetTimePeriod from './MobilePresetTimePeriod';
import withComponentName from '../../../decorators/withComponentName';

import Styles from '../story-filters-styles.module.scss';

const cx = classNames.bind(Styles);

const PresetTimePeriod = ({
  setTimeFilter, selectedFilterValue, periodValues, premiumValues,
  silver, customTimeFilter, width, hasBigScreenDesign,
}) => (
  <>
    {width > 767 ? (
      <div
        className={cx('time-filter-item', 'preset-filter')}
      >
        <h2>Preset</h2>
        <ul>
          {periodValues.map(({ value, name }) => (
            <li key={value}>
              <RoundRadioButton
                name={name}
                value={value}
                setValue={setTimeFilter}
                selectedFilterValue={selectedFilterValue}
                filterType="predefined"
                filterItemInfo={{
                  selected_time_filter: 'predefined',
                  time_filter: value,
                  displayedName: name,
                }}
                hasBigScreenDesign={hasBigScreenDesign}
              />
            </li>
          ))}
        </ul>
        {!!premiumValues.length && (
          <>
            <Link className={cx('premium-icon-badge', 'preset-icon-badge')} to="/pricing">
              <div className={Styles['premium-silver-icon-badge-container']}>
                <div className={Styles['premium-silver-icon-badge']}>
                  SILVER
                </div>
                <div className={Styles['silver-tooltip']}>
                  {silver ? 'This is available only to Premium subscribers' : 'Upgrade your plan to Silver to use this feature'}
                </div>
              </div>
            </Link>
            <ul className={cx({ disabled: !customTimeFilter })}>
              {premiumValues.map(({ value, name }) => (
                <li key={name}>
                  <RoundRadioButton
                    name={name}
                    value={value}
                    setValue={setTimeFilter}
                    selectedFilterValue={selectedFilterValue}
                    filterType="predefined"
                    filterItemInfo={{
                      selected_time_filter: 'predefined',
                      time_filter: value,
                      displayedName: name,
                    }}
                    hasBigScreenDesign={hasBigScreenDesign}
                  />
                </li>
              ))}
            </ul>
          </>
        )}
      </div>
    ) : (
      <MobilePresetTimePeriod
        setTimeFilter={setTimeFilter}
        selectedFilterValue={selectedFilterValue}
        periodValues={periodValues}
        premiumValues={premiumValues}
        silver={silver}
        customTimeFilter={customTimeFilter}
        width={width}
      />
    )}
  </>
);

export default withComponentName(PresetTimePeriod);
